/**
 * 本机能力自检。
 *
 * 提醒相关的几种能力，在手机浏览器上并不是「代码写得好就有」，
 * 有几项是操作系统层面的硬限制，换任何写法都绕不过去：
 *
 *  - iPhone 的 Safari 从未实现 Vibration API，网页在 iPhone 上永远无法振动。
 *    这是苹果的限制，不是本应用的问题。
 *  - iPhone 的语音播报只允许在「用户刚点过屏幕」之后发声，
 *    系统定时触发的自动播报在锁屏或页面在后台时不会响。
 *  - 所有手机在页面切到后台或锁屏后，定时器都会被系统暂停，
 *    依赖页面轮询的提醒自然也就不再触发。
 *
 * 所以与其让用户点了开关却毫无反应，不如把结果直接摊开告诉他。
 */

export function hasSpeechSynthesis() {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

export function hasAudioContext() {
  if (typeof window === 'undefined') return false;
  return !!(window.AudioContext || window.webkitAudioContext);
}

export function hasVibrate() {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return false;
  // 光有 API 不算数：桌面版 Chrome 身上也挂着 navigator.vibrate，
  // 但电脑没有振动马达，报 ✓ 会让用户以为「到点会震」，实际什么都不会发生。
  // 前缀既然改成了「本设备」，就要按设备说话 —— 有振动马达的基本都是触屏设备，
  // 用「触摸点数 + 移动端 UA」兜一道，电脑上如实标 ✗。
  const touch = typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 0;
  const mobileUA = /Android|iPhone|iPad|iPod|Mobile|HarmonyOS/i.test(navigator.userAgent || '');
  return touch || mobileUA;
}

export function hasSpeechRecognition() {
  if (typeof window === 'undefined') return false;
  return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
}

export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13 起 Safari 会把自己伪装成 macOS，只能靠触摸点数量区分
  return (
    navigator.platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1
  );
}

/** 一次性拿到全部结论，供设置页展示 */
export function getDeviceSummary() {
  return {
    speech: hasSpeechSynthesis(),
    sound: hasAudioContext(),
    vibrate: hasVibrate(),
    recognition: hasSpeechRecognition(),
    ios: isIOS(),
  };
}
